
import { getToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'
import { post } from '@/utils/request'

import cookie from '@/utils/cookie'

const state = {
  token: getToken(),
  userid: '',
  username: '',
  factoryid: '',
  lineid: '',
  clientname: '',
  roles: [],
  name: '',
  avatar: '',
  asrouter: [],
  btns: [],
  roleMemuList: [],
  currentRoute: ''
}

const mutations = {
  SET_USERID: (state, userid) => {
    state.userid = userid
  },
  SET_CURRENTROUTE: (state, currentRoute) => {
    state.currentRoute = currentRoute
  },
  SET_USERNAME: (state, username) => {
    state.username = username
  },
  SET_FACTORYID: (state, factoryid) => {
    state.factoryid = factoryid
  },
  SET_LINEID: (state, lineid) => {
    state.lineid = lineid
  },
  SET_CLIENTNAME: (state, clientname) => {
    state.clientname = clientname
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_ASYROTER: (state, asrouter) => {
    state.asrouter = asrouter
  },
  SET_BTNS: (state, btns) => {
    state.btns = btns
  },
  SET_ROLEMEMULIST: (state, roleMemuList) => {
    state.roleMemuList = roleMemuList
  }
}

const actions = {
  SET_FACTORYID({ commit }, id) {
    state.factoryid = id
  },
  SET_LINEID({ commit }, id) {
    state.lineid = id
  },
  // 登录
  Login({ commit }, loginForm) {
    return new Promise((resolve, reject) => {
      post('/login', loginForm).then(response => {
        commit('SET_USERID', response.data.userId)
        commit('SET_USERNAME', response.data.userName)
        commit('SET_FACTORYID', response.data.factoryId)
        commit('SET_LINEID', response.data.lineId)
        cookie.setCookie(cookie.userid_cookie, response.data.userId)
        cookie.setCookie(cookie.factoryid_cookie, response.data.factoryId)
        cookie.setCookie(cookie.lineid_cookie, response.data.lineId)
        cookie.setCookie(cookie.username_cookie, response.data.userName)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 登出
  Logout({ commit }) {
    return new Promise((resolve, reject) => {
      post('/logout').then(() => {
        commit('SET_USERID', '')
        commit('SET_FACTORYID', '')
        commit('SET_LINEID', '')
        cookie.removeCookie(cookie.userid_cookie)
        cookie.removeCookie(cookie.factoryid_cookie)
        cookie.removeCookie(cookie.assemblylineid_cookie)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 前端 登出
  FedLogout({ commit }) {
    return new Promise(resolve => {
      commit('SET_USERID', '')
      commit('SET_FACTORYID', '')
      commit('SET_LINEID', '')
      cookie.removeCookie(cookie.userid_cookie)
      cookie.removeCookie(cookie.factoryid_cookie)
      cookie.removeCookie(cookie.assemblylineid_cookie)
      resolve()
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      // const params = {
      //   userId: cookie.getCookie('userid')
      // }
      // post('/baperuser/getUserRoleList', params).then(response => {
      // const { data } = response
      // if (!data) {
      //   reject('Verification failed, please Login again.')
      // }
      const info = {
        'name': '管理员',
        'introduction': null,
        'avatar': null,
        'roles': [
          'admin'
        ],
        'authorities': []
      }
      const { roles, name, authorities } = info
      commit('SET_ROLES', roles)
      commit('SET_NAME', name)
      commit('SET_BTNS', authorities)
      resolve(info)
      // }).catch(error => {
      //   reject(error)
      // })
      // post('baPerPermission/getThirdLevelMenuListInformation', params).then(response => {
      // const { data } = response
      const data = [
        {
          'title': '报警信息查询',
          'updateUserName': '管理员',
          'menuParentId': '0',
          'component': 'views/MacAlarmInformationHistory',
          'insertUserName': '管理员',
          'redirect': null,
          'sortOrder': 69,
          'icon': null,
          'menuId': '180000',
          'path': '/MacAlarmInformationHistory',
          'insertDate': '2020-03-06 15:44:58',
          'alwaysShow': 0,
          'updateDate': '2020-03-06 15:44:58',
          'insertUserId': '10001',
          'updateUserId': '10001',
          'version': 1,
          'englishTitle': 'Equipment Alarm Inquiry',
          'id': null
        },
        {
          'title': '设备台账',
          'updateUserName': '管理员',
          'menuParentId': '140000',
          'component': 'views/MacRepParameter',
          'insertUserName': '管理员',
          'redirect': '',
          'sortOrder': 89,
          'icon': '',
          'menuId': '140601',
          'path': 'MacRepParameter',
          'insertDate': '2021-01-25 16:09:00',
          'alwaysShow': 0,
          'updateDate': '2021-01-25 16:09:00',
          'insertUserId': '10001',
          'updateUserId': '10001',
          'version': 1,
          'englishTitle': 'moratin',
          'id': null
        }
      ]
      commit('SET_ROLEMEMULIST', data)
      resolve(data)
      // }).catch(error => {
      //   reject(error)
      // })
    })
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      post('/logout', state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removeToken()
        resetRouter()

        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, { root: true })

        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  setRouteId({ commit }, id) {
    return new Promise(resolve => {
      commit('SET_CURRENTROUTE', id)
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js